import moment from 'moment'
import apipos from '../../services/service_pos'
import SaleDetailView from '../../components/report/report_sale_detail'
import SalePosDetailView from '../../components/report/report_sale_pos_detail'
import SaleCreditDetailView from '../../components/report/report_sale_credit_detail'
import SaleHoldDetailView from '../../components/report/report_sale_hold_detail'
import SaleSumView from '../../components/report/report_sale_summary'

export default {
  components: {
    SaleDetailView,
    SalePosDetailView,
    SaleCreditDetailView,
    SaleHoldDetailView,
    SaleSumView
  },
  data () {
    return {
      tab: 99,
      host_list: [],
      host: '',
      branch: 0,
      start_date: moment(new Date()),
      end_date: moment(new Date()),
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      hour_list: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12',
        '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
      minute_list: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09',
        '10', '11', '12', '13', '14', '15', '16', '17', '18', '19',
        '20', '21', '22', '23', '24', '25', '26', '27', '28', '29',
        '30', '31', '32', '33', '34', '35', '36', '37', '38', '39',
        '40', '41', '42', '43', '44', '45', '46', '47', '48', '49',
        '50', '51', '52', '53', '54', '55', '56', '57', '58', '59'],
      second_list: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09',
        '10', '11', '12', '13', '14', '15', '16', '17', '18', '19',
        '20', '21', '22', '23', '24', '25', '26', '27', '28', '29',
        '30', '31', '32', '33', '34', '35', '36', '37', '38', '39',
        '40', '41', '42', '43', '44', '45', '46', '47', '48', '49',
        '50', '51', '52', '53', '54', '55', '56', '57', '58', '59'],
      s_h: '00',
      e_h: '23',
      s_m: '00',
      e_m: '59',
      s_s: '00',
      e_s: '59',
      start_time: '000000',
      end_time: '235959'
    }
  },
  methods: {
    getHost () {
      apipos.getHostShift(
        sessionStorage.Url,
        this.header,
        result => {
          if (result.response === 'success') {
            this.host_list = result.data
            this.host = this.host_list[0]
            this.tab = 0
          } else {
            this.alert_msg('warning', 'ดึงข้อมูลจุดขายไม่ได้', result.message)
          }
        },
        error => {
          this.alert_msg('error', 'ข้อมูลไม่ถูกต้อง', error.data.error)
        }
      )
    },
    setStartTime () {
      this.start_time = this.s_h + this.s_m + this.s_s
    },
    setEndTime () {
      this.end_time = this.e_h + this.e_m + this.e_s
    }
  },
  mounted () {
    this.getHost()
    this.getBranch()
    this.setStartTime()
    this.setEndTime()
    // setTimeout(() => {
    //   this.branch = this.$store.state.branch_list[0]
    // }, 200)
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/report_sale.js